import React from 'react';
import FormLink from '../../../../library/form/components/FormLink'
import FormROValue from '../../../../library/form/components/FormROValue1';

const VoucherRefListRow = (props) => {
    const { formObject, rowKey } = props;

    return (

        <div className="uiInlineFloat5">
            <div style={{minHeight:"40px"}} className="uiBoxHeader uiContentCenter uiBorderRoundAll">
                <FormLink formObject={formObject} rowKey={rowKey} qvIconKey='print' linkProp={{ target: "_blank" }} className="uiMainBlockClear uiColumnCenter uiLinkRow"
                    action={{ paramName: "voucherLink", actionId: "show" }} anchorStyle={{minHeight:"40px"}}
                >
                    <div className="uiInfoBlock">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "voucherDate" }} className="uiSpacerH5"/>
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "voucherAmount" }} className="uiHighlightKey" />
                    </div>
                    <div className="uiInfoBlock">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "voucherDesc" }}/>
                    </div>
                </FormLink>

            </div>
        </div>

    )
}

export default VoucherRefListRow